export { VirtualProviderGroupDetailExpertise } from './VirtualProviderGroupDetailExpertise';
